import {latLng} from "leaflet";
import {Countries} from "../../consts/countryTypes";

export const getClosestMarkerOrDefault = (latlng, markersData) => {
    let markers = [...markersData];
    let closestMarker = getClosestMarker(latlng, markers);
    closestMarker = {
        lat: closestMarker?.Position?.Latitude,
        lng: closestMarker?.Position?.Longitude,
    };
    let coordsToShow = isMarkerWithinRadius(latlng, latLng(closestMarker))
        ? latlng
        : closestMarker;

    return coordsToShow;
};

const isMarkerWithinRadius = (marker, closestMarker) =>
    marker.distanceTo(closestMarker) < 20000;

const getClosestMarker = (targetMarker, markers) =>
    markers.reduce((prev, current) => {
        if (prev?.Position && current?.Position) {
            const {Latitude: prevLat, Longitude: prevLng} = prev.Position;
            const {Latitude: currentLat, Longitude: currentLng} = current.Position;
            let distanceToPrev = targetMarker.distanceTo(latLng(prevLat, prevLng));
            let distanceToCurrent = targetMarker.distanceTo(
                latLng(currentLat, currentLng)
            );

            return distanceToPrev > distanceToCurrent ? current : prev;
        }
        return;
    });
export const getClosestMarkers = (lat, lng, markers) => {
    let targetMarker = latLng(lat, lng);
    let closestMarkers = markers.filter((marker) => {
        if (!marker?.Position) {
            return;
        }
        const {Latitude, Longitude} = marker?.Position;

        return isMarkerWithinRadius(targetMarker, latLng(Latitude, Longitude));
    });

    if (!closestMarkers.length) {
        closestMarkers = [getClosestMarker(targetMarker, markers)];
    }
    return closestMarkers;
};

export const getLatLangsFromMarkersData = (markers) => {
    return markers.map((marker) => {
        if (!marker?.Position) {
            return;
        }
        const {Latitude, Longitude} = marker.Position;
        return latLng(Latitude, Longitude);
    });
};
export const getTwoLetterIsoArray = (countries) => {
    let twoLetterIsoArray = [];
    countries.map((country) => {
        switch (country) {
            case Countries.Sweden:
                twoLetterIsoArray.push("se");
                break;
            case Countries.Poland:
                twoLetterIsoArray.push("pl");
                break;
            case Countries.Netherlands:
                twoLetterIsoArray.push("nl");
                break;
            case Countries.Norway:
                twoLetterIsoArray.push("no");
                break;
            case Countries.Denmark:
                twoLetterIsoArray.push("dk");
                break;
            case Countries.Finland:
                twoLetterIsoArray.push("fi");
                break;
            case Countries.German:
                twoLetterIsoArray.push("de");
                break;
        }
    });
    return twoLetterIsoArray;
};

export const MapBoxUrl =
    "https://api.mapbox.com/styles/v1/norlandia-maps/cldlpeprx001g01qqt82n090x/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1Ijoibm9ybGFuZGlhLW1hcHMiLCJhIjoiY2xka284ZGdiMjNpMTNwcXAweGoyZHY0biJ9.k99kuJ1BcJBj1gDj8nIb4w";
